// Filename - components/HeroImage.js

import React, {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function HeroImage (){
    useEffect(() => {
        AOS.init({
            disable: "phone",
            duration: 700,
            easing: "ease-out-cubic",
          });
      }, [])

    return (
    <header style={{ paddingLeft: 0 }}>
        
        <div
            className='p-5 text-center bg-image'
            style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.75), rgba(255,255,255,0.75)), url(/images/site/intelligence-network.jpg)", height: 400 }}
        >
      
            <div className='d-flex justify-content-center align-items-center h-100'>
                <div data-aos="zoom-in" data-aos-delay="100">
                    <h1 style={{color: '#639fdd', fontSize: '80px'}} className='mb-3'>Innovation</h1>
                    <h4 style={{color: '#c87137'}} className='mb-3'>The secret to thriving in the age of AI</h4>
                </div>
            </div>   
        
        </div>


    </header>
    )

}
